var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Layout",
    {
      attrs: {
        clientId: _vm.clientId,
        showid: 0,
        ads: _vm.ads,
        channels: _vm.channels,
        setTitle: _vm.title,
        apiOrigin: _vm.apiOrigin
      }
    },
    [
      _c("div", [
        _c("div", { staticClass: "backgroud1" }, [
          _c("div", { staticClass: "backgroud2" }, [
            _vm.newsBig && _vm.newsBig.length > 0
              ? _c("section", { staticClass: "headline" }, [
                  _c("div", { staticClass: "outer clear" }, [
                    _c("div", { staticClass: "lf" }, [
                      _c("div", [
                        _vm._v("\n                关"),
                        _c("br"),
                        _vm._v("\n                注\n              ")
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "news" }, [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.newsBig.length > 0,
                              expression: "newsBig.length > 0"
                            }
                          ],
                          staticClass: "bold",
                          staticStyle: { "font-size": "40px" }
                        },
                        _vm._l(_vm.newsBig, function(item, index) {
                          return _c(
                            "a",
                            {
                              key: index,
                              attrs: { type: item.id, target: "_blank" },
                              on: {
                                click: function($event) {
                                  _vm.clickAction(item)
                                }
                              }
                            },
                            [_vm._v(_vm._s(item.title))]
                          )
                        })
                      ),
                      _vm._v(" "),
                      _vm.newsSmall.length > 3
                        ? _c(
                            "div",
                            _vm._l(_vm.newsSmall, function(item, index) {
                              return _c(
                                "a",
                                {
                                  key: index,
                                  attrs: { type: item.id, target: "_blank" },
                                  on: {
                                    click: function($event) {
                                      _vm.clickAction(item)
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(item.title))]
                              )
                            })
                          )
                        : _c(
                            "div",
                            _vm._l(_vm.newsSmall, function(item, index) {
                              return _c(
                                "a",
                                {
                                  key: index,
                                  attrs: { type: item.id, target: "_blank" },
                                  on: {
                                    click: function($event) {
                                      _vm.clickAction(item)
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(item.title))]
                              )
                            })
                          )
                    ])
                  ])
                ])
              : _vm._e()
          ])
        ]),
        _vm._v(" "),
        _c(
          "section",
          {
            staticClass: "outer news_scroll",
            staticStyle: { "padding-top": "22px", "padding-bottom": "0" }
          },
          [
            _vm.newsLunbo && _vm.newsLunbo.length > 0
              ? _c("div", { staticClass: "news_scroll" }, [
                  _c("div", { staticClass: "clear" }, [
                    _c("div", { staticClass: "scroll" }, [
                      _c("div", { staticClass: "lf" }, [_vm._v("滚 动")]),
                      _vm._v(" "),
                      _c("div", { staticClass: "rt" }, [
                        _c("div", { staticClass: "scroll_container" }, [
                          _c("div", { staticClass: "box" }, [
                            _c(
                              "div",
                              { staticClass: "s1" },
                              _vm._l(_vm.newsLunbo, function(item, index) {
                                return _c(
                                  "a",
                                  {
                                    key: index,
                                    attrs: { type: item.id, target: "_blank" },
                                    on: {
                                      click: function($event) {
                                        _vm.clickAction(item)
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(item.title))]
                                )
                              })
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "s2" },
                              _vm._l(_vm.newsLunbo, function(item, index) {
                                return _c(
                                  "a",
                                  {
                                    key: index,
                                    attrs: { type: item.id, target: "_blank" },
                                    on: {
                                      click: function($event) {
                                        _vm.clickAction(item)
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(item.title))]
                                )
                              })
                            )
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              : _vm._e()
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "article" },
          [
            _vm.ads.slide.items
              ? _c("swiper", {
                  attrs: { list: _vm.ads.slide.items, type: "1" }
                })
              : _vm._e(),
            _vm._v(" "),
            _c("publicList", {
              attrs: { list: _vm.newsList, clientId: _vm.clientId }
            }),
            _vm._v(" "),
            _c(
              "a",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.meta.page_count > _vm.meta.current_page,
                    expression: "meta.page_count > meta.current_page"
                  }
                ],
                staticClass: "more",
                attrs: {
                  disabled: _vm.showMore == "加载中",
                  href: "javascript:;",
                  id: "pc-more"
                },
                on: { click: _vm.more }
              },
              [_vm._v(_vm._s(_vm.showMore))]
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      _vm.newsList.length == 0 ||
                      _vm.meta.page_count == _vm.meta.current_page,
                    expression:
                      "newsList.length == 0 || meta.page_count == meta.current_page"
                  }
                ],
                staticClass: "more",
                attrs: { href: "javascript:;", id: "pc-more" }
              },
              [_vm._v("没有更多了")]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "aside aside-bside" },
          [
            _c(
              "div",
              { staticClass: "aside aside-bside" },
              [
                _vm.clientId == 321300
                  ? _c("rankingAside", {
                      attrs: { list: _vm.reWenList, title: "排行榜" }
                    })
                  : _c("newsAside", {
                      attrs: { list: _vm.reWenList, title: "热文" }
                    }),
                _vm._v(" "),
                _vm.clientId !== 410600
                  ? _c("news-aside", {
                      attrs: { list: _vm.bianMinList, title: "便民" }
                    })
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c("adAside", {
              attrs: { list: _vm.ads.slideBars, clientId: _vm.clientId }
            }),
            _vm._v(" "),
            _vm.clientId == 321300
              ? _c(
                  "a",
                  { attrs: { href: "https://www.12377.cn", target: "_blank" } },
                  [
                    _c("img", {
                      staticStyle: {
                        width: "320px",
                        height: "95px",
                        display: "block",
                        margin: "0 auto"
                      },
                      attrs: { src: "/public/w/img/321300/jubao.jpg" }
                    })
                  ]
                )
              : _vm._e()
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-c96d6c72", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c96d6c72","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/web/page/news-pc/index.vue
// module id = null
// module chunks = 